import { cn } from "@/lib/helpers/cn";
import type { HtmlHTMLAttributes } from "react";

export function Main2({ className, ...mainProps }: HtmlHTMLAttributes<HTMLDivElement>) {
  return (
    <main
      className={cn(
        "tw:!flex tw:flex-col tw:gap-5",
        "tw:max-lg:mx-8 tw:lg:mx-auto tw:lg:w-full tw:lg:!max-w-245 tw:xl:!max-w-285",
        className,
      )}
      {...mainProps}
    />
  );
}
